import script from "./LeftNavBar.vue?vue&type=script&setup=true&lang=js"
export * from "./LeftNavBar.vue?vue&type=script&setup=true&lang=js"

import "./LeftNavBar.vue?vue&type=style&index=0&id=a89b45ac&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a89b45ac"]])

export default __exports__